import { __awaiter } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { FetchStatus } from '@as-react/common-types';
import { useState, useEffect } from 'react';
import CustomerApi from '../../api/customer/CustomerApi';
import { AccountCreditCard } from '../../components/account/account-credit-card/AccountCreditCard';
const AccountCreditCardContainer = ({ title }) => {
    const { defaultRequestParams, servicesEndpoint } = useAemConfig();
    const [status, setStatus] = useState(FetchStatus.PENDING);
    const [creditCards, setCreditCards] = useState([]);
    const [deleteError, setDeleteError] = useState(false);
    const fetchCreditCards = () => __awaiter(void 0, void 0, void 0, function* () {
        setStatus(FetchStatus.PENDING);
        try {
            const data = yield CustomerApi.getCardInfo(servicesEndpoint, defaultRequestParams);
            setCreditCards(data);
            setStatus(FetchStatus.RESOLVED);
        }
        catch (_a) {
            setStatus(FetchStatus.REJECTED);
        }
    });
    const removeCard = (cardId) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setDeleteError(false);
            yield CustomerApi.deleteCard(servicesEndpoint, defaultRequestParams, cardId);
            fetchCreditCards();
        }
        catch (_a) {
            setDeleteError(true);
        }
    });
    useEffect(() => {
        fetchCreditCards();
    }, []);
    return (_jsx(AccountCreditCard, { ogoneAliases: creditCards, status: status, deleteError: deleteError, removeCard: removeCard, title: title }));
};
export default AccountCreditCardContainer;
